/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  toggleAccordionMainBox: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  mobileCarousel: {
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      margin: '0 1.25rem 0 -0.438rem',
      justifyContent: 'space-evenly',
    },
  },
  PrequalBannerCurve: {
    width: '100%',
  },
  SecondaryPrequalBannerCurve: {
    width: '100%',
    height: { xs: '2.75rem', sm: '2.875rem', lg: '4rem' },
  },
  toggleAccordionRoot: {
    boxShadow: 'none',
    margin: '0 !important',
    width: '100%',

    '& .Mui-expanded': {
      minHeight: 'unset !important',
      margin: '0 !important',
      borderRadius: '0',
    },
    '& .MuiCollapse-root': {
      textAlign: 'center',
    },
    [theme.breakpoints.up('sm')]: {
      width: '18.25rem',
      top: '-2.4rem',
      height: '38px',
    },
  },
  fadedContainer: {
    zIndex: 1,
    // [theme.breakpoints.down('sm')]: {
    //   boxShadow: '0 0 0 100vmax rgba(0,0,0,0.3)',
    // },
  },
  toggleAccordionSummaryRoot: {
    background: theme.palette.primary.offerMain,
    borderRadius: '0 0 10px 10px',
    padding: '0.5rem',
    minHeight: '2.5rem',
    columnGap: '0.625rem',
    color: theme.palette.primary.contrastText,

    '& .MuiAccordionSummary-content': {
      fontFamily: theme.typography.body1.fontFamily,
      color: theme.palette.primary.contrastText,
      fontStyle: 'normal',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      flexGrow: '0',
      margin: '0',
    },
  },
  expandMoreIcon: {
    color: theme.palette.primary.contrastText,
  },
  toggleAccordionContent: {
    cursor: 'pointer',
    padding: '0.4375rem',
    fontFamily: theme.typography.body1.fontFamily,
    color: theme.palette.primary.contrastText,
    borderRadius: '0 0 10px 10px',
    fontStyle: 'normal',
    fontSize: '1rem',
    lineHeight: '1.5rem',
    boxShadow: `0px 5px 5px -3px  ${theme.palette.primary.boxShadow2Dark}, 0px 8px 10px 1px  ${theme.palette.primary.boxShadow2Medium}, 0px 3px 14px 2px  ${theme.palette.primary.boxShadow2Lite}`,
    background: theme.palette.secondary.light,
    ':hover': {
      background: theme.palette.primary.toggleHover,
    },
  },
  imageSlider: {
    swiper: {
      [theme.breakpoints.up('lg')]: {
        width: '73rem',
      },
      '& .content-carousel': {
        height: { xs: 'fit-content', md: 500 },
        pt: 2,
        pl: { xs: '1rem' },
        pr: 2.5,
        pb: 8,
      },
      '& .content-carousel .swiper-slide': {
        width: '100%',
        mr: 1,
        maxHeight: { xs: 'fit-content', md: 500 },
        [theme.breakpoints.down('sm')]: {
          ml: '-4px !important',
          mr: '10px !important',
        },
      },
      '& .content-carousel .swiper-wrapper': {
        [theme.breakpoints.down('sm')]: {
          maxWidth: '380px',
        },
      },
      '& .swiper-pagination-bullet-active': {
        backgroundColor: theme.palette.primary.buttonColor,
      },
      '& .content-carousel .swiper-slide img': {
        height: { xs: 142 },
        m: '0 auto',
        display: 'block',
      },
      '& .content-carousel .swiper-button-next, .content-carousel .swiper-button-prev': {
        bgcolor: theme.palette.primary.contrastText,
        height: 30,
        width: 30,
        borderRadius: 30,
        '&:after': {
          fontSize: 16,
          color: theme?.palette?.secondary.dark,
          fontWeight: 700,
        },
      },
    },
    swiperIndex: {
      '& .image-selector': {
        maxHeight: 500,
      },
      '& .image-selector .swiper-slide': {
        // background: 'yellow',
        width: '100%',
        height: 'fit-content !important',
      },
      '& .image-selector .swiper-slide img': {
        // background: 'yellow',
        width: '100%',
        height: 'auto',
      },
      '& .image-selector .swiper-button-next': {
        bgcolor: theme.palette.primary.contrastText,
        height: 30,
        width: '100%',
        top: 'unset',
        bottom: 0,
        left: 0,
        right: 0,
        opacity: 0.5,
        '&:after': {
          fontSize: 16,
          fontWeight: 700,
          color: theme?.palette?.secondary.dark,
          transform: 'rotate(90deg)',
        },
      },
      '& .image-selector .swiper-button-prev': {
        bgcolor: theme.palette.primary.contrastText,
        height: 30,
        width: '100%',
        m: 0,
        top: 0,
        left: 0,
        right: 0,
        opacity: 0.5,
        '&.swiper-button-disabled': {
          display: 'none',
        },
        '&:after': {
          fontSize: 16,
          fontWeight: 700,
          color: theme?.palette?.secondary.dark,
          transform: 'rotate(90deg)',
        },
      },
    },
  },
});

export default styles;
